module.exports = __webpack_public_path__ + "static/media/ImageLoading.c6179d77.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ImageLoading.gif
// module id = 458
// module chunks = 1